import { useState } from "react";
import { FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import { t } from '../../i18n/runtime';
import './header-top-news.css';

const THEME_BG = {
    dark:   'linear-gradient(100deg, #0a1520 0%, #0f2030 40%, #091828 100%)',
    teal:   'linear-gradient(100deg, #041f1d 0%, #082e2b 40%, #031514 100%)',
    orange: 'linear-gradient(100deg, #1a0e00 0%, #2d1a00 40%, #120a00 100%)',
    red:    'linear-gradient(100deg, #1a0505 0%, #2d0808 40%, #120303 100%)',
    violet: 'linear-gradient(100deg, #0f0a1a 0%, #1a0f2d 40%, #090312 100%)',
};

const HeaderTopNews = ({
    badge = t('Limited Time Offer'),
    text = <>{t('Get Trendline IQ for')} <strong>{t('-25% off.')}</strong></>,
    code,
    ctaLabel = t('Purchase Now'),
    ctaHref = 'https://themeforest.net/checkout/from_item/33571911?license=regular',
    ctaExternal = true,
    theme = 'dark',
}) => {
    const [deactive, setClass] = useState('');
    const [copied, setCopied] = useState(false);

    const copyCode = () => {
        if (!code) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).catch(() => { });
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 1800);
    };

    return (
        <div className={`header-top-news bg_image ${deactive}`} style={{ background: THEME_BG[theme] || THEME_BG.dark }} role="region" aria-label={t('Site announcement')}>
            <div className="wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="inner">
                                <div className="content">
                                    <span className="rn-badge">{badge}</span>
                                    <span className="news-text">{text}</span>
                                    {code && (
                                        <button
                                            type="button"
                                            className="promo-code"
                                            onClick={copyCode}
                                            aria-label={`${t('Copy coupon code')} ${code}`}
                                        >
                                            <span className="promo-code__label">{t('Use Code')}</span>
                                            <span className="promo-code__value">{code}</span>
                                            <span className="promo-code__hint">{copied ? t('Copied!') : t('Click to Copy')}</span>
                                        </button>
                                    )}
                                </div>
                                <div className="right-button">
                                    {ctaExternal ? (
                                        <a
                                            className="btn-read-more ti-btn ti-btn--ghost"
                                            href={ctaHref}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <span>{ctaLabel}</span>
                                        </a>
                                    ) : (
                                        <Link className="btn-read-more ti-btn ti-btn--ghost" to={ctaHref}>
                                            <span>{ctaLabel}</span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="icon-close">
                <button className="close-button" aria-label={t('Dismiss announcement')} onClick={() => setClass('deactive')}><FiX /></button>
            </div>
        </div>
    )
}

export default HeaderTopNews;
